import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import currency from "slotworks/i18n/currency";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import gameState from "slotworks/model/game-state";

export default class CelebrateWinMultiplierComponent {

    public TOTAL_COUNTUP_TIME: number = 2000;
    public TOTAL_WAIT_TIME: number = 1300;

    private tween: TweenJS.Tween;
    private timer: number;

    private tickUpComplete: boolean;
    private transitionComplete: boolean;
    private completeResolve: Function;

    public totalWin(win: number) {
        return new Contract<void>((resolve) => {
            this.tickUpComplete = this.transitionComplete = false;

            this.completeResolve = () => resolve(null);
            this.hide();

            if (win <= 0 || !Layers.CelebrationContent.hasScene("bonusWin")) {
                resolve(null);
                return;
            }

            const setup = () => {                
                Components.footer.showGameWin(win);
                const countTime = this.TOTAL_COUNTUP_TIME;
                this.tickUp(Layers.CelebrationContent.getText("value"), win, countTime, this.TOTAL_WAIT_TIME);
            };

            Layers.CelebrationContent.setScene("bonusWin", setup).then(() => {
                this.transitionComplete = true;            
                this.complete();
            });
        });
    }

    public hide() {
        if (this.tween) {
            this.tween.stop();
        }
        Timer.clearTimeout(this.timer);

        Layers.CelebrationContent.jumpToScene("default");
    }

    private tickUp(text: PIXI.Text, targetValue: number, duration: number, wait: number) {
        SoundManager.customEvent("multiplier_award_10x");
        const tickObj = {
            value: 0
        };
        this.tween = new TweenJS.Tween(tickObj)
            .to({value: targetValue}, duration)
            .onUpdate(() => {
                text.text = currency.format(tickObj.value, undefined, undefined, true, true);
            })
            .onComplete(() => {
                text.text = currency.format(tickObj.value, undefined, undefined, true);
                this.timer = Timer.setTimeout(() => {
                    this.tickUpComplete = true;
                    this.complete();
                }, wait);
            })
            .start();
    }

    private complete() {
        regulation.updateNetPosition(gameState.getNetPosition());
        if (this.tickUpComplete && this.transitionComplete) {
            Layers.CelebrationContent.defaultScene().then(() => this.completeResolve());
        }
    }
}
